if (!customElements.get('bundle-products')) {
  class ProductBundles extends HTMLElement {
    constructor() {
      super()

      this.mainProductId = this.dataset.mainProductId;
      this.mainProductTitle = this.dataset.mainProductTitle;
      this.mainProductUrl = this.dataset.mainProductUrl;
      this.variantSelectors = this.querySelectorAll('select[data-variant-selector]');
      this.erroMessageField = this.querySelector('[data-error-message]');
      this.messages = {};

      this.messages.outOfStock = this.dataset.outOfStockMessage;
      this.messages.emptyVariant = this.dataset.emptyVariant;
    }

    connectedCallback() {
      this.attachEvents()
    }

    attachEvents() {
      document.addEventListener('dcb:change-bundle-variant', this.validateVariantAvailable.bind(this));
      document.addEventListener('dcb:submit-bundle', this.validate.bind(this));
    }

    validateVariantAvailable(event) {
      let bundlelHasUnavailableProducts = false;

      this.variantSelectors.forEach(variantSelector => {
        if (variantSelector.value == event.detail.id) return;

        const selectedOption = variantSelector.querySelector(`option[value="${variantSelector.value}"]`);
        const availableVariant = selectedOption.dataset.available;

        if (availableVariant === 'false') {
          bundlelHasUnavailableProducts = true;
        }
      });

      if (event.detail.available === 'true' && event.detail.variantTitle !== '') {
        if (!bundlelHasUnavailableProducts) {
          document.dispatchEvent(new CustomEvent('dcb:bundle-is-available'));

          this.handleErrorMessage();
        }

        return;
      };

      let message = '';

      if (event.detail.available === 'false') {
        message = this.messages.outOfStock.replace('[[variantTitle]]', event.detail.variantTitle);
      } else if (event.detail.variantTitle === '') {
        message = this.messages.emptyVariant;
      }

      this.handleErrorMessage(message);

      document.dispatchEvent(new CustomEvent('dcb:bundle-is-sold-out'));
    }

    validate() {
      let hasError = false;

      this.variantSelectors.forEach(variantSelector => {
        const selectedOption = variantSelector.querySelector(`option[value="${variantSelector.value}"]`);
        const variantTitle = selectedOption.textContent;
        const availableVariant = selectedOption.dataset.available;

        if (variantSelector.value === '') {
          this.handleErrorMessage(this.messages.emptyVariant);

          hasError = true;

          return;
        }

        if (availableVariant === 'false') {
          this.handleErrorMessage(this.messages.outOfStock.replace('[[variantTitle]]', variantTitle));

          hasError = true;

          return;
        }
      });

      if (!hasError) {
        this.handleErrorMessage();

        document.dispatchEvent(new CustomEvent('dcb:bundle-is-valid', { detail: { mainProductId: this.mainProductId, mainProductTitle: this.mainProductTitle, mainProductUrl: this.mainProductUrl, variants: this.variantSelectors }}));
      }
    }

    handleErrorMessage(message = '') {
      if (message === '') {
        this.erroMessageField.classList.add('hidden');

        return;
      }

      this.erroMessageField.textContent = message;

      this.erroMessageField.classList.remove('hidden');
    }
  }

  customElements.define('bundle-products', ProductBundles)
}
